import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { CountdownTimer } from './CountdownTimer';

const CountdownTimerBridge = react2angular(CountdownTimer, [
  'title',
  'seconds',
  'onCountdownFinished'
]);

export default CountdownTimerBridge;
